import PageIndex from '../../views/Admin/Config/Page/PageIndex';
import PageEdit from '../../views/Admin/Config/Page/PageEdit';
import PageCreate from '../../views/Admin/Config/Page/PageCreate';
import LayoutPrimary from '../../layouts/Primary';
import Page from '@/views/Public/Page';

export default [
    {
        path: '/page/create',
        name: 'PageCreate',
        component: PageCreate,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/page/index',
        name: 'PageIndex',
        component: PageIndex,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/page/edit/:id',
        name: 'PageEdit',
        component: PageEdit,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/page/:slug',
        name: 'Page',
        component: Page,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    }
];
